import { render, staticRenderFns } from "./renovation.vue?vue&type=template&id=5540370e&scoped=true&"
import script from "./renovation.vue?vue&type=script&lang=js&"
export * from "./renovation.vue?vue&type=script&lang=js&"
import style0 from "./renovation.vue?vue&type=style&index=0&id=5540370e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5540370e",
  null
  
)

export default component.exports